import { fromJS } from 'immutable';
import { REHYDRATE } from 'redux-persist-immutable/constants';
import docCookies from 'cookies-js';

import * as actions from './actions';

const initialState = fromJS({
  currentUserId: null,
  initialized: false,
  oauthUri: null,
  email: null,
  isLoggedIn: false,
});

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case REHYDRATE: {
      return state
        .merge(action.payload.session)
        .set('initialized', false);
    }

    case actions.INITIALIZE.SUCCESS: {
      return state.set('initialized', true);
    }

    case actions.DEAUTH.REQUEST: {
      docCookies.expire('BEARER');
      return initialState.set('initialized', true);
    }

    case actions.DEAUTH.SUCCESS: {
      docCookies.expire('BEARER');
      return initialState.set('initialized', true);
    }

    case actions.AUTH.SUCCESS: {
      docCookies.set('BEARER', action.payload.token, { expires: Infinity });
      return state.merge({
        isLoggedIn: true,
        oauthUri: action.payload.oauthUri,
        currentUserId: action.payload.currentUserId,
        email: action.payload.email,
      });
    }

    case actions.TWO_FACTOR_AUTH.SUCCESS: {
      docCookies.set('BEARER', action.payload.token, { expires: Infinity });
      return state.merge({
        isLoggedIn: true,
        oauthUri: null,
      });
    }

    default:
      return state;
  }
}
